import { Box } from '@mui/material'
import { Icon as Iconify } from '@iconify/react'
import Ribbon from 'components/common/Ribbon/Ribbon'
import RibbonButton from 'components/common/Ribbon/RibbonComponents/RibbonButton'
import { checkPermission } from 'components/userPermissions'

const ReportGroupRibbon = ({
  selectedGroup,
  onRefresh,
  onAddGroup,
  onEditGroup,
  onDeleteGroup,
  onTestGroup,
  isDeleting,
  userRole,
}) => {
  const panels = []

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={<Iconify icon='material-symbols:refresh' width={20} />}
          label='Refresh'
          onClick={onRefresh}
        />
      </Box>,
    ],
  })

  if (selectedGroup) {
    panels.push({
      panelName: '',
      items: [
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='ic:baseline-email' width={20} />}
            label='Test'
            onClick={onTestGroup}
          />
        </Box>,
      ],
    })
  }

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={<Iconify icon='material-symbols:add' width={20} color='green' />}
          label='Add Group'
          onClick={onAddGroup}
        />

        {selectedGroup && (
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:edit' width={20} color='#1976d2' />}
            label='Edit'
            onClick={onEditGroup}
          />
        )}

        {checkPermission('canDelete', userRole.roleAttributes?.permissions) && selectedGroup && (
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:delete' width={20} color='#d32f2f' />}
            label='Delete'
            disabled={isDeleting}
            onClick={() => onDeleteGroup(selectedGroup)}
          />
        )}
      </Box>,
    ],
  })

  return <Ribbon barHeight={90} tabs={[{ panels }]} />
}

export default ReportGroupRibbon
